import React from "react";
import { useTheme } from "styled-components";
import { MiniSpinnerSvg } from "./styles";

/**
 * Mini spinner circular — anel cinza + arco accent girando. Usado em
 * botões e linhas inline. Tamanho controlado por prop `size` (default 14).
 */
export default function MiniSpinner({ size = 14, color, label = "Processando" }) {
  const theme = useTheme();
  const stroke = color || theme.accent;
  const radius = 5.5;
  const strokeWidth = 1.6;
  const center = 8;
  const circumference = 2 * Math.PI * radius;
  const arcLength = circumference * 0.28;
  const gap = circumference - arcLength;

  return (
    <MiniSpinnerSvg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      role="img"
      aria-label={label}
    >
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke={theme.border}
        strokeWidth={strokeWidth}
      />
      <circle
        cx={center}
        cy={center}
        r={radius}
        fill="none"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray={`${arcLength.toFixed(2)} ${gap.toFixed(2)}`}
        strokeDashoffset={0}
      />
    </MiniSpinnerSvg>
  );
}
